import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";

import "./index.css";
import App from "./App";
// import * as serviceWorker from "./serviceWorker";

import "normalize.css/normalize.css";
import "@blueprintjs/core/lib/css/blueprint.css";

import filesReducer from "./store/reducers/files";
import runtimeReducer from "./store/reducers/runtime";
import predictionReducer from "./store/reducers/predictions";
import authReducer from "./store/reducers/auth";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  files: filesReducer,
  predictions: predictionReducer,
  runtime: runtimeReducer,
  auth: authReducer,
});

const dataStore = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const app = (
  <Provider store={dataStore}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
// serviceWorker.register();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
